import { toColorString, parseToRgb } from 'polished';

export default function normalizeColor(color: string) {
  return toColorString(parseToRgb(color));
}
